import { generatePath, useHistory } from 'react-router-dom'

import { Button } from 'blaze-ui/Button'
import { Lightning } from 'blaze-ui/icons'

import Styles from './VirtualMarketerUpgradeCta.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { useVirtualMarketerPlan } from './hooks/useVirtualMarketerPlan'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useModals } from 'almanac-ui/Modal'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { useOnboardingTracking } from 'hooks/useOnboardingTracking'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { sendToApi } from 'api/client'
import { UserService } from 'api/clients/UserService'
import { VIRTUAL_MARKETER_ONBOARDING_PATH } from 'paths'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UPGRADED_FROM_WORKSPACE_ID } from './VirtualMarketerPlansModal/components/CreditCardForm/CreditCardForm'
import { VirtualMarketerPreparingModal } from './VirtualMarketerPreparingModal/VirtualMarketerPreparingModal'

export const VirtualMarketerUpgradeCta = () => {
  const { data: virtualMarketerPlan, isLoading } = useVirtualMarketerPlan()
  const currentWorkspaceId = useCurrentWorkspaceId()
  const workspaces = useWorkspaces()
  const { openModal, closeModal, closeAllModals } = useModals()
  const { trackOnboardingWorkspaceCreated } = useOnboardingTracking()
  const history = useHistory()

  const openVirualMarketerPreparingModal = async () => {
    if (!virtualMarketerPlan) {
      showToastMessage('Unable to fetch plan. Please contact support', 'error')
      return
    }

    const price = virtualMarketerPlan.prices.find((p) => p.recurring.interval_count === 1 && !p.metadata.additional_key)

    if (!price) {
      showToastMessage('Unable to fetch plan. Please contact support', 'error')
      return
    }

    openModal(VirtualMarketerPreparingModal)

    const res = await sendToApi(`/w/${currentWorkspaceId}/virtual_marketers`, {
      body: { price_id: price.id },
      method: 'POST',
    })

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      localStorage.setItem(UPGRADED_FROM_WORKSPACE_ID, currentWorkspaceId.toString())

      const newWorkspace = res.data.company

      trackOnboardingWorkspaceCreated()

      UserService.setWorkspaces([...workspaces, newWorkspace])
      UserService.setCurrentWorkspaceId(newWorkspace.id)

      closeAllModals()
      history.push(generatePath(VIRTUAL_MARKETER_ONBOARDING_PATH, { workspaceId: newWorkspace.id }))
    } else {
      closeModal()
      showToastMessage('An error occurred. Try again. Contact support if the issue persists.', 'error')
    }
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.text}>
        <div className={Styles.heading}>
          <Heading level={5} color="var(--purple-70)">
            Meet Blaze Autopilot
          </Heading>
          <span className={Styles.pill}>
            <Text variant="metadata" color="var(--light-100)">
              New
            </Text>
          </span>
        </div>
        <Text variant="secondary" color="var(--purple-70)">
          AI that plans, creates, and posts content while you run your business. Get 100%+ monthly growth on autopilot.
        </Text>
      </div>
      <div>
        <Button
          frontIcon={Lightning}
          variant="primary"
          onPress={openVirualMarketerPreparingModal}
          isDisabled={isLoading}
        >
          Start Now
        </Button>
      </div>
    </div>
  )
}
